<template>
  <div>
    <div class="info">
      <div class="bulle-info" @click="toggle"></div>
      <div class="cross" @click="fullscreen" v-if="hasFullScreenListener"></div>
      <div class="bulle" v-show="show">
        <div class="bulle-text">
          <h3>{{$t(title)}}</h3>
          <p>{{$t(text)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Info',
    props: {
      title: String,
      text: String
    },
    data() {
      return {
        show: false
      }
    },
    mounted() {
    },
    methods: {
      toggle() {
        this.show = !this.show
      },
      fullscreen() {
        this.$emit('fullscreen')
      }
    },
    computed: {
       hasFullScreenListener(){
        return this.$listeners && this.$listeners.fullscreen
      }
    },
    watch : {
      show:function(val) {
        let that = this
        if(val == true) {
          window.addEventListener('click', function(event){
            if(event.target.className != 'bulle-info' && !event.target.classList.contains('bulle-text')) {
              that.show = false
            }
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/info.sass"
</style>
